import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const DeleteConfirmModal = ({ isOpen, player, onClose, onConfirm }) => {
  if (!isOpen || !player) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: "rgba(0,0,0,0.55)" }} onClick={(e) => e?.target === e?.currentTarget && onClose()}>
      <div className="w-full max-w-sm rounded-2xl shadow-2xl p-6" style={{ backgroundColor: "var(--color-card)" }}>
        <div className="flex flex-col items-center text-center gap-3">
          <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{ backgroundColor: "rgba(220,38,38,0.1)" }}>
            <Icon name="Trash2" size={26} color="var(--color-error)" />
          </div>
          <h3 className="font-heading font-semibold text-lg" style={{ color: "var(--color-foreground)" }}>Delete Player</h3>
          <p className="font-caption text-sm" style={{ color: "var(--color-muted-foreground)" }}>
            Are you sure you want to remove <strong style={{ color: "var(--color-foreground)" }}>{player?.name}</strong> from the roster? This action cannot be undone.
          </p>
        </div>
        <div className="flex gap-3 mt-6">
          <Button variant="outline" fullWidth onClick={onClose}>Cancel</Button>
          <Button variant="destructive" fullWidth iconName="Trash2" iconPosition="left" onClick={() => onConfirm(player?.id)}>Delete</Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;